module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_6_4.aa6ead8f.jpeg";